// Shared billing types + helpers used across the app shell, the billing page,
// and the marketing pricing page — single source of truth so the SubscriptionPlan
// presenter shape and the allowance-meter math can't drift between pages.

export type SubscriptionPlanCard = {
  key: string
  tier: string
  name: string
  tagline: string
  interval: "month" | "year"
  monthly_allowance: number
  price_cents: number
  per_thousand_cents: number
  savings_vs_neverbounce_pct: number
  popular: boolean
  features: string[]
}

// Allowance meter math, shared by the sidebar meter and the billing banner.
export function allowanceMeter(total: number | null | undefined, remaining: number | null | undefined) {
  const t = total || 0
  const r = remaining ?? 0
  // Clamp both ends: remaining > total (e.g. a not-yet-synced downgrade) must
  // not render a negative "% used".
  const usedPct = t > 0 ? Math.min(100, Math.max(0, Math.round(((t - r) / t) * 100))) : 0
  return { total: t, remaining: r, usedPct }
}

// Low-balance warning tone shared by the sidebar credits meter and the billing
// page usage bar, so the two never disagree about what "running low" means.
export function creditTone(remaining: number): "red" | "amber" | "violet" {
  return remaining < 250 ? "red" : remaining < 1000 ? "amber" : "violet"
}

export function formatPrice(cents: number) {
  return cents % 100 === 0 ? `$${(cents / 100).toLocaleString()}` : `$${(cents / 100).toFixed(2)}`
}

export function formatPerCredit(cents: number) {
  const dollars = cents / 100
  return `$${dollars.toFixed(4).replace(/0+$/, "").replace(/\.$/, ".0")}`
}
